export function useClickOutside(element, handler) {
  const listener = (event) => {
    if (!element.contains(event.target)) {
      handler(event);
    }
  };

  document.addEventListener("click", listener);

  return () => {
    document.removeEventListener("click", listener);
  };
}
